module.exports = __webpack_public_path__ + "img/depthMap-verdoemd240.1179ab84.png";